export const isAuthenticated = (auth) => {
    return auth && auth.userData
}